import React from 'react'
import cx from 'classnames'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { DropdownAnchor } from './common/DropdownAnchor/DropdownAnchor'
import { DropdownMenu } from './common/DropdownMenu/DropdownMenu'

type ActionsDropdownProps = {
  actions?: unknown[]
  anchorClassName?: string
  isDisabled?: boolean
  menuClassName?: string
  size?: string
}

export const ActionsDropdown = ({
  actions,
  anchorClassName,
  menuClassName,
  isDisabled = false,
  size,
}: ActionsDropdownProps) => (
  <Dropdown hasArrow>
    <DropdownAnchor
      ariaLabel="actions"
      className={cx(anchorClassName)}
      {...{ size, isDisabled }}
    />
    <DropdownMenu className={cx(menuClassName)} {...{ actions }} />
  </Dropdown>
)
